/* unplugin-vue-components disabled */import { render } from "./UserSearchResult.vue?vue&type=template&id=2131e1e5&scoped=true&ts=true"
import script from "./UserSearchResult.vue?vue&type=script&lang=ts"
export * from "./UserSearchResult.vue?vue&type=script&lang=ts"

import "./UserSearchResult.vue?vue&type=style&index=0&id=2131e1e5&lang=scss&scoped=true"
import "./UserSearchResult.vue?vue&type=style&index=1&id=2131e1e5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2131e1e5"]])

export default __exports__